import { useSelector } from "react-redux";
import { useFormContext } from "react-hook-form";
import { LISTING_TYPES } from "repoV2/features/Listing/Listing.constants";
import { IRepoV2ReduxState } from "repoV2/features/Common/modules/Reducer/Reducer.interface";
import { useCheckoutBasicDetailsContext } from "../modules/CheckoutBasicDetailsContextProvider";
import { IOrderBumpsFormValues } from "../modules/PaymentDetailsSection/modules/FormGroups/modules/OrderBumpsFormGroup/OrderBumpsFormGroup.interfaces";
import { order_bumps_form_key } from "../modules/PaymentDetailsSection/modules/FormGroups/modules/OrderBumpsFormGroup/OrderBumpsFormGroup.constants";
import { getShowAddressFields } from "./getShowAddressFields";

export const useGetAddressDetailsHelpers = () => {
    const { watch } = useFormContext();
    const { listingUuid, listingType } = useCheckoutBasicDetailsContext();

    const priceDetails =
        useSelector(
            (state: IRepoV2ReduxState) =>
                state.checkoutPages.listingDetails[listingUuid]?.priceSection
                    ?.data
        ) || {};

    const selectedOrderBumpsListings: IOrderBumpsFormValues =
        watch(order_bumps_form_key) || {};

    const isMerchandiseOrderBumpSelected = Object.values(
        selectedOrderBumpsListings
    ).some(
        listing => listing.listingDetails.type === LISTING_TYPES.MERCHANDISE
    );

    const showInternationalInputFields =
        priceDetails?.showInternationalInputFields || false;

    const { showAddressOutsideUserDetails } = getShowAddressFields({
        listingType,
        showInternationalInputFields,
        isMerchandiseOrderBumpSelected,
    });

    return { showDeliveryDetailsFormGroup: showAddressOutsideUserDetails };
};
